import configJson from '@/content/help/_config.json';

export interface SupportChannelsConfig {
  contactEmail: string;
  supportHours: string;
  responseSla: string;
  phoneE164?: string;
  phoneDisplay?: string;
  whatsappE164?: string;
  calComUsername?: string;
  calComEvent?: string;
}

export function getSupportConfig(): SupportChannelsConfig {
  const cfg = configJson as Record<string, unknown>;
  return {
    contactEmail: (cfg.contactEmail as string) ?? 'contact@softfactura.ro',
    supportHours: (cfg.supportHours as string) ?? 'Luni-Vineri 9-18',
    responseSla: (cfg.responseSla as string) ?? '24h în zilele lucrătoare',
    phoneE164: cfg.phoneE164 as string | undefined,
    phoneDisplay: cfg.phoneDisplay as string | undefined,
    whatsappE164: cfg.whatsappE164 as string | undefined,
    calComUsername: cfg.calComUsername as string | undefined,
    calComEvent: cfg.calComEvent as string | undefined,
  };
}

/**
 * In timpul orelor de suport (L-V 9-18, Europe/Bucharest).
 * Returneaza true daca esti acum in interval; false in weekend sau in afara orelor.
 */
export function isWithinSupportHours(now: Date = new Date()): boolean {
  const ro = new Date(
    now.toLocaleString('en-US', { timeZone: 'Europe/Bucharest' }),
  );
  const day = ro.getDay();
  const hour = ro.getHours();
  return day >= 1 && day <= 5 && hour >= 9 && hour < 18;
}
